module.exports = __webpack_public_path__ + "img/activity-lottery-end.daf1202b.jpg";